import styled from 'styled-components'

import { mediaMax } from 'styles/media'

import HeartIcon from '../../components/icons/Heart'
import LocationPinIcon from '../../components/icons/LocationPin'
import ShowMoreText from '../../components/ShowMoreText'

import ImageOrSlider from '../../components/cards/shared/ImageOrSlider'
import MediaWrapper from '../../components/cards/shared/MediaWrapper'

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.textGreyLight};
  border-radius: 6px;
  overflow: hidden;

  ${mediaMax.md`
    border-radius: 0;
  `}

  ${({ embedded }) =>
    embedded &&
    `
    border: none;
  `}
`

const Content = styled.div`
  padding: 30px 40px;

  @media (max-width: 767px) {
    padding: 40px 20px;
  }

  ${({ embedded }) =>
    embedded &&
    `
    padding: 16px 24px;
  `}
`

const Likes = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  svg {
    color: #ed5565;
    width: 16px;
    height: 16px;
    margin-right: 12px;
  }
`

const Title = styled.div`
  margin-bottom: 16px;
  font-size: 20px;
  color: #333;
`

const Description = styled.div`
  line-height: 1.8;
  font-size: 16px;
`

const Icon = styled.i`
  font-size: 24px;
  margin-right: 12px;
  color: black;
`

const Location = styled.a`
  display: block;
  margin-top: 40px;
  color: ${({ theme }) => theme.brand.jungle};

  svg {
    display: inline-block;
    height: 16px;
    margin-right: 6px;
  }
`

const StoryStepCard = ({
  adventure_type,
  photos,
  likes,
  title,
  description,
  location,
  showLocation,
  embedded,
  url,
}) => (
  <Wrapper embedded={embedded}>
    <MediaWrapper rounded={false}>
      <ImageOrSlider photos={photos} />
    </MediaWrapper>

    <Content embedded={embedded}>
      {likes && (
        <Likes>
          <HeartIcon /> {likes}
        </Likes>
      )}
      <Title>
        {!embedded && (
          <Icon className={`icon icon-mid icon-${adventure_type.slug}`} />
        )}
        {title && <a href={url}>{title}</a>}
      </Title>
      <Description>
        <ShowMoreText>{description}</ShowMoreText>
      </Description>
      {showLocation && (
        <Location
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            location.name,
          )}`}
          target="_blank"
        >
          <LocationPinIcon /> <span>{location.name}</span>
        </Location>
      )}
    </Content>
  </Wrapper>
)

export default StoryStepCard
